interface IllnessIconProps {
  className?: string;
}

export function IllnessIcon({ className }: IllnessIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="30"
      viewBox="0 0 23 30"
      fill="none"
      className={className}
    >
      <path
        d="M11.8454 18.5232L13.8073 11.8076L15.498 17.0612H18.041V18.6451H14.3772L14.3129 18.4438L13.8782 17.0961L11.7736 24.3079L9.4714 15.6237L8.26455 18.6451H4.04102V17.0612H7.2231L9.76909 10.6905L11.8454 18.5232Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5484 1.93548H16.4516V2.90323H22.2581V30H0V2.90323H5.80645V1.93548H8.70968V0H13.5484V1.93548ZM1.45161 4.35484V28.5484H20.8065V4.35484H16.4516V6.77419H5.80645V4.35484H1.45161ZM9.67742 2.90323H6.77419V5.80645H15.4839V2.90323H12.5806V0.967742H9.67742V2.90323Z"
        fill="currentColor"
      />
    </svg>
  );
}
